export default __webpack_public_path__ + "static/media/briefcase.ba8c4e66.svg";